export default __webpack_public_path__ + "static/media/image2.a270c0f2.jpg";